// @ts-nocheck
import Select from "react-select";

export const AIOptionSelector = ({
    options,
    onChange,
    value,
    // placeholder = "Sélectionnez...",
    isDisabled = false
}) => (
    <Select
        options={options}
        onChange={({ value }) => onChange(value)}
        // placeholder={placeholder}
        defaultValue={options[0]}
        isDisabled={isDisabled}
        className="ai-option-selector"
    />
);